import React from 'react';
import { X, Check } from 'lucide-react';
const rows = [{
  situation: 'Acción',
  without: 'Dudás antes de actuar',
  with: 'Respondés con claridad'
}, {
  situation: 'Decisiones',
  without: 'Pensás demasiado',
  with: 'Decidís rápido'
}, {
  situation: 'Presión',
  without: 'Te bloqueás',
  with: 'Tenés protocolos claros'
}, {
  situation: 'Turno',
  without: 'Terminás agotada',
  with: 'Tenés control mental'
}, {
  situation: 'Confianza',
  without: 'Baja',
  with: 'Alta'
}, {
  situation: 'Resultado',
  without: 'Estrés',
  with: 'Seguridad'
}];
export function ComparisonTable() {
  return <section className="bg-brand-dark py-12 px-5" data-id="element-60">
      <div className="max-w-xl mx-auto" data-id="element-61">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-62">
          La diferencia es clara
        </h2>

        <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden mb-10" data-id="element-63">
          <div className="grid grid-cols-3 text-center text-xs font-bold border-b border-gray-800" data-id="element-64">
            <div className="p-3 text-gray-500" data-id="element-65">Situación</div>
            <div className="p-3 text-red-400 bg-red-950/20" data-id="element-66">Sin Sistema</div>
            <div className="p-3 text-green-400 bg-green-950/20" data-id="element-67">
              Con Mente Clínica™
            </div>
          </div>
          {rows.map((row, idx) => <div key={idx} className="grid grid-cols-3 text-center border-b border-gray-800/50 last:border-b-0" data-id="element-68">
              <div className="p-3 text-xs font-medium text-gray-400 flex items-center justify-center" data-id="element-69">
                {row.situation}
              </div>
              <div className="p-3 bg-red-950/10 flex flex-col items-center justify-center gap-1" data-id="element-70">
                <X size={16} className="text-red-500" data-id="element-71" />
                <span className="text-[11px] text-gray-500" data-id="element-72">{row.without}</span>
              </div>
              <div className="p-3 bg-green-950/10 flex flex-col items-center justify-center gap-1" data-id="element-73">
                <Check size={16} className="text-green-500" data-id="element-74" />
                <span className="text-[11px] text-white font-medium" data-id="element-75">
                  {row.with}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}